/**
 * Billing Edit only changes Large Report Fee. The grid row is not a full StateReport
 * payload — posting it would wipe Status, TypeOfReport, and client-complete flags.
 */

export type BillingLargeReportPatch = {
  stateReportId: number;
  largeReport: boolean | string | number | null | undefined;
  largeReportFee?: string | number | null;
};

export function isLargeReportFlag(value: unknown): boolean {
  if (value === true || value === 1) return true;
  const normalized = String(value ?? "").trim().toLowerCase();
  return normalized === "true" || normalized === "1";
}

/** Billing Edit shows Large Report Fee for Super Admin when the row is a Large Report (BIT 1 / true) or already has a fee. */
export function shouldShowBillingLargeReportFeeInput(
  largeReport: unknown,
  largeReportFee: unknown,
  canEdit: boolean
): boolean {
  if (!canEdit) return false;
  if (isLargeReportFlag(largeReport)) return true;
  return largeReportFee !== undefined && largeReportFee !== null && String(largeReportFee).trim() !== "";
}

/**
 * Given the full report from GetStateReportById and the Billing Edit values,
 * When building the AddEdit payload, Then keep filing fields and overlay only
 * Large Report / Large Report Fee.
 */
export function applyBillingLargeReportToExistingReport(
  existing: Record<string, unknown> | null | undefined,
  patch: BillingLargeReportPatch
): Record<string, unknown> {
  if (!existing || typeof existing !== "object") {
    throw new Error("State report was not found. The billing row was not changed.");
  }

  const { documents, ...rest } = existing;
  const largeReport = isLargeReportFlag(patch.largeReport);

  return {
    ...rest,
    stateReportId: patch.stateReportId,
    largeReport,
    largeReportFee: largeReport ? patch.largeReportFee ?? "" : "",
  };
}
